<template>
  <div>
    <div class="row">
      <div class="col-12 mt-3" v-if="product">
        <HMCustomContent
          :html="product.product_description"
          :json="product.product_description_new"
        />
      </div>
    </div>
    <div
      v-if="isPrivateCoaching && product.use_internal_scheduling"
      class="mt-4"
    >
      <h4>{{ $t('PRODUCTS.LABELS.MY_AVAILABILITY') }}</h4>
      <span>
        {{ $t('PRODUCTS.TEXT.AVAILABILITY_DESCRIPTION') }}
      </span>
      <PrivateSchedulingCalendar
        class="mt-4"
        :studioURL="studioUrl"
        :productId="product.id"
        :duration="product.time_slot_duration"
        :readOnly="true"
        @booked="() => {}"
      />
    </div>
    <div v-if="false">
      <div class="py-5" v-for="item in salesPageItems" :key="item.key">
        <component
          :is="salesPageComponentsMapper[item.key]"
          :data="item.data"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import StudioSimpleContentPreview from '@/web/components/products/StudioSimpleContentPreview';
import StudioSignUpBannerPreview from '@/web/components/products/StudioSignUpBannerPreview';
import StudioTestimonialPreview from '@/web/components/products/StudioTestimonialPreview';
import StudioInstructorsPreview from '@/web/components/products/StudioInstructorsPreview';
import StudioFaqPreview from '@/web/components/products/StudioFaqPreview';
import StudioLessonsPreview from '@/web/components/products/StudioLessonsPreview';
import StudioEventsPreview from '@/web/components/products/StudioEventsPreview';
import HMCustomContent from '@/web/components/common/HMCustomContent';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import PrivateSchedulingCalendar from './PrivateSchedulingCalendar';

export default Vue.extend({
  name: 'StudioProductAbout',
  components: {
    HMCustomContent,
    PrivateSchedulingCalendar,
    StudioSimpleContentPreview,
    StudioSignUpBannerPreview,
    StudioTestimonialPreview,
    StudioInstructorsPreview,
    StudioFaqPreview,
    StudioLessonsPreview,
    StudioEventsPreview,
  },
  data() {
    return {
      salesPageComponentsMapper: {
        introduction: 'StudioSimpleContentPreview',
        solution: 'StudioSimpleContentPreview',
        sign_up_banner: 'StudioSignUpBannerPreview',
        testimonial: 'StudioTestimonialPreview',
        instructors: 'StudioInstructorsPreview',
        results: 'StudioSimpleContentPreview',
        bonus: 'StudioSimpleContentPreview',
        faq: 'StudioFaqPreview',
        // included_content: StudioIncludedContentPreview,
        included_events: 'StudioEventsPreview',
        included_lessons: 'StudioLessonsPreview',
      },
    };
  },
  computed: {
    ...mapGetters({
      product: 'product/product',
      salesPageItems: 'product/salesPageItems',
      canViewProductContent: 'product/canViewProductContent',
    }),
    isPrivateCoaching() {
      return this.product?.product_type === 'private_coaching';
    },
    studioUrl() {
      return getStudioURL(this.$route);
    },
  },
});
</script>
